<template>
  <div class="pageContent">
    <div class="pageTitleBox">
      <img src="../../assets/images/contact2.png" alt="logo" class="pageTitleIcon">联系我们
    </div>
    <div class="pageContentContact">
      <div class="pageContentContactLeft">
        <div class="pageContentContactTop">邮箱：mse@zjut.edu.cn</div>
        <div class="pageContentContactTop">地址：浙江工业大学莫干山校区（湖州市德清县长虹东街999号）材料楼</div>
      </div>
      <div class="pageContentContactRight">
        <img src="../../assets/images/ditu.png" alt="map" class="map">
      </div>
    </div>
  </div>
</template>

<script>
  import {
    http
  } from '@/utils/http'

  export default {
    name: 'contact',
    data() {
      return {
        data: {}
      }
    },
    created() {
      this.onload()
    },
    methods: {
      onload() {
        http('/contact-us/getContact', 'GET').then(res => {
          if (res.success) {
            this.data = res.data
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .pageContent {
    width: 1200px;
    margin: 18px auto;
    padding: 0 14px 33px;
  }

  .pageTitleBox {
    margin-bottom: 12px;
  }

  .listItem {
    height: 140px;
    border-bottom: 1px solid #D9D9D9;
    // display: inline-block;
  }

  .pageContentContact {
    display: flex;
    align-content: flex-end;
  }

  .pageContentContactLeft {
    width: 800px;
  }

  .pageContentContactTop {
    margin-top: 12px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pageContentContactRight {
    margin-top: 12px;
    margin-left: 88px;
  }

  .map {
    width: 474px;
    height: 308px;
  }
</style>
